import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ConfigService } from 'src/app/infrastructure/services/config-services/config.service';
import { RequestLoadingService } from 'src/app/infrastructure/services/loading-services/request-loading.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

// Footer-progressbar voor server-verzoeken die via HttpClient lopen i.p.v. ApiService (login, 2FA,
// registratie, wachtwoord-acties in AuthService) — zie RequestLoadingService. Alleen verzoeken naar
// de eigen API/auth-server (geen /assets, vertalingen e.d.), en niet de refresh-token-call: die loopt
// op de achtergrond (timer/app-start) en hoort geen zichtbare voortgang te geven.
export function progressInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const __configService = injectRequired(ConfigService);
    const __requestLoadingService = injectRequired(RequestLoadingService);

    const __url = request.url;
    const __rootApi = __configService.rootApi$$();
    const __rootAuth = __configService.rootAuth$$();
    const __isServerUrl = (!!__rootApi && __url.includes(__rootApi)) || (!!__rootAuth && __url.includes(__rootAuth));
    const __isBackground = __url.includes('/refresh-token');

    if (!__isServerUrl || __isBackground) return next(request);

    __requestLoadingService.add();
    return next(request).pipe(
        finalize(() => __requestLoadingService.remove()),
    );
}
